const initialState = []

export default function reducer(state: Array = initialState, action: Object = {}) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/media.js